import { writable } from "svelte/store";
export const toasts = writable([]);
export let defaultOptions = {
    dismissible: false,
    position: "bottom-left",
    timeout: 5000,
    type: "info"
};
export const dismissToast = (id) => {
    toasts.update((currentToasts) => {
        return currentToasts.filter((t) => {
            return t.id !== id;
        });
    });
};
export const addToast = (toast) => {
    const id = Math.ceil(Date.now() * Math.random() * 100).toString();
    const toastData = { ...defaultOptions, ...toast, id };
    toasts.update((currentToasts) => {
        return [...currentToasts, ...[toastData]];
    });
    if (toastData.timeout) {
        setTimeout(() => {
            dismissToast(id);
        }, toastData.timeout);
    }
};
